module.exports = __webpack_public_path__ + "static/media/card_header.7ef6cfca.svg";